import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SesionState } from './session.interface';

export const _SELECT_SESION_FEATURE =
  createFeatureSelector<SesionState>('sesion-management');

export const _MAIN_PARAMS_STATE = createSelector(
  _SELECT_SESION_FEATURE,
  state => {
    return {
      id: state.sesion.id,
      email: state.sesion.email,
      code: state.sesion.code,
      token: state.sesion.token,
      pantalla: state.sesion.pantalla?.replaceAll('-', '_'),
      id_wf: state.sesion.id_wf,
      id_cat_wf_solicitud: state.sesion.id_cat_wf_solicitud,
      medio_envio_codigo: state.sesion.medio_envio_codigo,
      numero_envio_codigo: state.sesion.numero_envio_codigo,
      mensaje: state.sesion.mensaje,
    };
  }
);

export const _HEADER_AUTH_STATE = createSelector(
  _SELECT_SESION_FEATURE,
  state => {
    return {
      id: state.sesion.id,
      token: state.sesion.token,
      id_wf: state.sesion.id_wf,
      id_cat_wf_solicitud: state.sesion.id_cat_wf_solicitud,
    };
  }
);

export const _DEFAULT_PARMAS_STATE = createSelector(
  _SELECT_SESION_FEATURE,
  state => {
    return {
      id: state.sesion.id,
      email: state.sesion.email,
    };
  }
);
export const _SESION_STATE = createSelector(_SELECT_SESION_FEATURE, state => {
  return {
    sesion: state.sesion,
  };
});
export const _SESION_RECHAZO = createSelector(_SELECT_SESION_FEATURE, state => {
  return {
    rechazo: state.sesion.mensaje,
  };
});
export const _SESION_MEDIO_ENVIO = createSelector(
  _SELECT_SESION_FEATURE,
  state => {
    return {
      medio_envio_codigo: state.sesion.medio_envio_codigo,
      numero_envio_codigo: state.sesion.numero_envio_codigo,
    };
  }
);

export const _SESION_AUTHENTICATED = createSelector(
  _SELECT_SESION_FEATURE,
  state => {
    return state.sesion.id == null || state.sesion.token == null;
  }
);

export const _SESION_EMAIL = createSelector(_SELECT_SESION_FEATURE, state => {
  return state.sesion.email;
});
export const _SESION_PANTALLA = createSelector(
  _SELECT_SESION_FEATURE,
  state => {
    return state.sesion.pantalla?.replaceAll('-', '_');
  }
);
